import { Text } from '@chakra-ui/react'
import { TextProps } from './utils'

const Caption = ({ children, color, ...textProps }: TextProps) => (
  <Text as="p" fontSize="xs" fontWeight={400} color={color} {...textProps}>
    {children}
  </Text>
)

export { Caption }
